export function checkCheckboxes(checkboxes: NodeListOf<HTMLInputElement>) {
  for (const checkbox of checkboxes) {
    checkbox.checked = true
  }
}

export function uncheckCheckboxes(checkboxes: NodeListOf<HTMLInputElement>) {
  for (const checkbox of checkboxes) {
    checkbox.checked = false
  }
}

export function configureCheckAllCheckbox(
  checkAll: HTMLInputElement,
  checkboxes: NodeListOf<HTMLInputElement>,
  actionButton?: HTMLButtonElement,
) {
  if (actionButton) {
    checkAll.addEventListener('change', () => {
      if (checkAll.checked) {
        checkCheckboxes(checkboxes)
        actionButton.disabled = false
      } else {
        uncheckCheckboxes(checkboxes)
        actionButton.disabled = true
      }
    })
  }
  for (const checkbox of checkboxes) {
    checkbox.addEventListener('click', () => {
      checkAll.checked = Array.from(checkboxes, ({ checked }) => checked).every(
        (e) => e,
      )
    })
  }
}

export function configureCheckboxActionButton(
  button: HTMLButtonElement,
  checkboxes: NodeListOf<HTMLInputElement>,
) {
  for (const checkbox of checkboxes) {
    checkbox.addEventListener('click', () => {
      if (button) {
        button.disabled = !Array.from(
          checkboxes,
          ({ checked }) => checked,
        ).some((e) => e)
      }
    })
  }
}
